import React from "react";
import Size from "shared/enums/Size";
import useManageMeetingRepCell from "./service";
import ToolTip from "shared/components/tooltip";
import CheckBox from "shared/form/core/checkbox";
import { useCopies } from "shared/hooks/useCopies";
import { ManageMeetingRepCellProps } from "./types";

export default function ManageMeetingRepCell(props: ManageMeetingRepCellProps) {
  const service = useManageMeetingRepCell(props);
  const copies = useCopies();

  return (
    <div className="manageOrgAdmin_orgAdminActions">
      {props.row.original.meetingRepTagAllowed ? (
        <CheckBox
          label={""}
          name={"manage"}
          size={Size.SMALL}
          checked={service.isMeetingRep}
          onChange={service.meetingRepChangeHandler}
          disabled={service.isMeetingRepTagChangeDisabled}
        />
      ) : (
        <React.Fragment>
          <span>{copies.get("n.a")}</span>
          <ToolTip
            size={Size.SMALL}
            content={copies.get("hosted.participant.can.not.be.meeting.rep.tooltip")}></ToolTip>
        </React.Fragment>
      )}
    </div>
  );
}
